const wrapperClasses = 'relative w-full';

const inputClasses = `
  block w-full h-11
  pl-2.5 pr-9 py-1.5
  text-base text-content
  bg-white border border-border-light rounded
  transition-colors
  focus:outline-none focus:border-primary focus:ring-1 focus:ring-primary-ring
`;

// Inset from the trailing edge, where the Arches search field puts it; the glass
// is Ocean, not the stray CSS `blue` keyword it used to carry.
const iconClasses = `
  fa-solid fa-magnifying-glass
  absolute right-3 top-1/2 -translate-y-1/2
  text-primary
`;

const SearchInput = ({ debouncedHandleSearchChange, placeholderText }) => (
  <div className={wrapperClasses}>
    <input
      type="search"
      onChange={debouncedHandleSearchChange}
      placeholder={placeholderText}
      aria-controls="myTable"
      className={inputClasses}
    />
    <i className={iconClasses} aria-hidden="true" />
  </div>
);

export default SearchInput;
